import { Component } from "vue"
import { TFunction } from "../utils"
import { RouteLocationRaw } from "vue-router"
import { IFlow, IStep, IStepAction } from "./flow.types"
import { ActionConditions } from "./flowRaw"
import { OutputType } from "@/flows/Deserializer"

export class StepAction implements IStepAction {
  constructor(
    public buttonLabel: string,
    public deserializeCondition: (
      condition: boolean | string,
    ) => Promise<boolean | string>,
    public buttonType?: string,
    public nextIf?: ActionConditions,
    public showIf?: OutputType,
    public showIfNot?: OutputType,
    public nextId?: string,
    public saveTo?: TFunction,
    public to?: string | RouteLocationRaw,
    public disabled?: boolean,
  ) {}

  async getNextStep() {
    if (this.nextId) return this.nextId
    if (!this.nextIf) return null

    for (const condition of this.nextIf) {
      if ("if" in condition) {
        const result = await this.deserializeCondition(condition.if ?? "")
        if (result) return condition.step
      } else {
        return condition.step
      }
    }
    return null
  }
}

export class Flow implements IFlow {
  constructor(
    public steps: IStep[],
    public helpTitle?: string,
    public helpContent?: Component,
  ) {}
}

export const getEmptyFlow = () => new Flow([])
